import React, { useContext } from 'react';
import styled from 'styled-components';
import { Container as BaseMuiContainer } from '@material-ui/core';
import { FormsContext } from '../../context';

type WrapProps = {
  'no-pad'?: boolean;
  embedded?: boolean;
};

type ContainerProps = {
  children: Omit<React.ReactNode, 'undefined'>;
  className?: string;
  noPad?: boolean;
};

const Wrap = styled.div<WrapProps>`
  color: ${(props) => props.theme.palette.text.primary};
  ${(props) =>
    props.embedded
      ? 'margin: 0px;'
      : 'width: calc(100vw - 40px); margin: 0 20px 0 20px;'}
  overflow: visible;
  ${(props) => (props['no-pad'] ? '' : 'padding: 15px 0;')}
  ${(props) => props.theme.breakpoints.down('xs')} {
    width: calc(100vw - 20px);
    margin: 0 5px 0 5px;
  }
  @media print {
    margin: 0;
    width: 100%;
  }
`;

const MuiContainer = styled(BaseMuiContainer)`
  ${(props) => props.theme.breakpoints.down('xs')} {
    && {
      padding-left: 4px;
      padding-right: 4px;
    }
  }
  @media print {
    padding: 0;
  }
`;
export const Container = ({ children, className, noPad }: ContainerProps) => {
  const { embedded } = useContext(FormsContext);

  return (
    <Wrap no-pad={noPad} embedded={embedded} className={className}>
      <MuiContainer>{children}</MuiContainer>
    </Wrap>
  );
};

export default Container;
